import * as React from "react";

function GridSquare2X2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M15 2H2v13h13V2zM4 13V4h9v9H4zM30 2H17v13h13V2zM19 13V4h9v9h-9zM2 17h13v13H2V17zm2 2v9h9v-9H4zm26-2H17v13h13V17zM19 28v-9h9v9h-9z",
    clipRule: "evenodd"
  }));
}

export default GridSquare2X2Icon;